module.exports = __webpack_public_path__ + "img/depthMap-bomber230.2ef1999e.png";